const TIME_ZONE_SUFFIX_PATTERN = /(Z|[+-]\d{2}:?\d{2})$/i

const padDatePart = (value: number) => String(value).padStart(2, '0')

export const formatCampaignReminderSendAt = (sendAt: Date) => {
  const year = sendAt.getUTCFullYear()
  const month = padDatePart(sendAt.getUTCMonth() + 1)
  const day = padDatePart(sendAt.getUTCDate())
  const hours = padDatePart(sendAt.getUTCHours())
  const minutes = padDatePart(sendAt.getUTCMinutes())
  const seconds = padDatePart(sendAt.getUTCSeconds())

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

export const parseCampaignReminderSendAt = (sendAt: Date | string) => {
  if (sendAt instanceof Date) {
    return new Date(sendAt.getTime())
  }

  return new Date(TIME_ZONE_SUFFIX_PATTERN.test(sendAt) ? sendAt : `${sendAt}Z`)
}
